// DO NOT EDIT BY HAND — populated by: npm run extract-letterform

import type { LetterMasters } from '@/types/letterform'

export const letterC: LetterMasters = {
  commands: ["M","H","V","H","V","H","V","H","V","H","V","H","V","Z"],
  narrowTall: [64,0,0,1024,64,484,32,768,28,128,32,480,64,0],
  wideShort: [1024,0,0,64,1024,32,520,48,516,8,520,28,1024,0],
  narrowArtboard: [64, 1024],
  wideArtboard: [1024, 64],
  minAspect: 0.0625,
  maxAspect: 16,
  minGaps: [{"indexA":5,"indexB":11,"minPx":1,"targetPx":4},{"indexA":6,"indexB":8,"minPx":1,"targetPx":4}],
  linkedPairs: [{"source":0,"target":4},{"source":0,"target":12},{"source":1,"target":13},{"source":6,"target":10}],
}
